import { UserRole } from "@/utils/enum/user-role";

/**
 * 의료기기 정보 페이지 URL을 가져오는 usecase
 */
export class GetMedicalDeviceInfoUrlUsecase {
  /**
   * 사용자 역할에 따라 의료기기 정보 페이지 URL을 반환합니다.
   * @param role 사용자 역할
   * @returns 의료기기 정보 페이지 URL
   */
  execute(role: UserRole | null): string {
    if (!role) {
      return "/medical-device-info";
    }

    switch (role) {
      case UserRole.SuperAdmin:
        return "/admin/home/medical-device-info";
      case UserRole.Doctor:
        return "/home/medical-device-info";
      default:
        return "/medical-device-info";
    }
  }
}
